export const players_headers = [
    { key: 'USERNAME', value: 'Player & ID', showArrowSort: true },
    { key: 'RISK_LEVEL', value: 'Risk Level', showArrowSort: false },
    { key: 'BASIC_ID', value: 'Basic ID', showArrowSort: false },
    { key: 'BASIC_INFO', value: 'Basic Info Obtained', showArrowSort: false },
    { key: 'PEP_CHECK', value: 'PEP Check', showArrowSort: false },
    { key: 'SANCTION_CHECK', value: 'Sanction Check', showArrowSort: false },
    {
        key: 'WITHDRAWALS',
        value: 'Accumulated Withdrawals',
        showArrowSort: false
    },
    { key: 'LAST_INFO', value: 'Last Info Gathered', showArrowSort: false },
    { key: 'ACTIONS', value: null, showArrowSort: false }
];
